<template>
    <div id="parentx" class="main-layout">
        <vue-progress-bar></vue-progress-bar>
        <sidebar @reduceButton="toggleReduce" @mobileMenu="toggleMobile"></sidebar>
        <div id="work-area" :class="[{'content-area-reduced': !reduce }, {'content-mobile': mobileMenu}]">
            <div class="router-view">
                <bread-crumb></bread-crumb>
                <router-view/>
            </div>  
        </div>  
    </div>
</template>
<script>
import BreadCrumb from '@/components/Header/Breadcrumb.vue'
import sidebar from '@/components/Sidebar.vue'
// import { Role } from '@/helpers/Role.js';
// import { mapState, mapActions } from 'vuex'
import { mapState, mapActions } from 'vuex'
export default {
  name: "Main-Layout",
  components: {
     BreadCrumb,
     sidebar
  },
  data () {
    return {
       reduce: false,
       mobileMenu: false
    }
  },
  watch: {
    reduceMenu () { this.reduce = this.reduceMenu },
    statusMenu () { this.mobileMenu = this.showMenuMobile },
    // statusMenu () { return this.$store.state.navMenuActive },
  },
  computed: {
    ...mapState([
      'reduceMenu',
      'menuMobile'
    ]),
    reduceMenu () { return this.$store.state.reduceMenu },
    statusMenu () { return this.$store.state.showMenuMobile }
  },
  methods: {
    ...mapActions([
      'showMenuMobile',
      'handleReduceMenu'
    ]),
    toggleReduce(_val){
      this.reduce = _val
      this.handleReduceMenu(_val)
    },
    toggleMobile(_val){
      this.mobileMenu = _val
      this.showMenuMobile(_val)
    }
  }
}
</script>
<style lang="stylus">
.parentx-static
  overflow hidden
  height 500px
  position relative

.header-sidebar
  display flex
  align-items center
  justify-content center
  flex-direction column
  width 100%
  h4
    display flex
    align-items center
    justify-content center
    width 100%
    > button
      margin-left 10px
.footer-sidebar
  display flex
  align-items center
  justify-content space-between
  width 100%
  > button
      border 0px solid rgba(0,0,0,0) !important
      border-left 1px solid rgba(0,0,0,.07) !important
      border-radius 0px !important

</style>